import { useQuery, UseQueryResult } from '@edreamsodigeo/frontend-api-client';

import {
  GetMembershipProductRequest,
  MembershipProductQuery,
  MembershipProductQueryVariables,
} from 'generated/graphql';
import { GET_MEMBERSHIP_PRODUCT } from 'clientState/providers/operations/membershipProduct';
import { useShoppingInfo } from './useShoppingInfo';

type queryResultParams = 'data' | 'errors' | 'loading';

export interface UseGetMembershipProduct {
  (): Pick<
    UseQueryResult<MembershipProductQuery['membershipProduct']>,
    queryResultParams
  >;
}

const useGetMembershipProduct: UseGetMembershipProduct = () => {
  const shoppingInfo = useShoppingInfo();
  const membershipProductRequest: GetMembershipProductRequest = {
    shoppingInfo,
  };

  const queryResult = useQuery<
    MembershipProductQuery,
    MembershipProductQueryVariables
  >(GET_MEMBERSHIP_PRODUCT, {
    variables: {
      membershipProductRequest,
    },
  });

  const { data, loading, errors } = queryResult;

  return { data: data?.membershipProduct, loading, errors };
};

export default useGetMembershipProduct;
